import userManager from '../../../store/domains/auth0/userManager';

const clearServerCookies = () => fetch('/application/logout-cleanup').catch(() => {});

export default function LogOutService(client) {
  // Use the environments variables
  // eslint-disable-next-line no-underscore-dangle
  const {
    REACT_APP_OAUTH_COGNITO_LOGOUT,
    REACT_APP_OAUTH_CLIENT_ID,
    REACT_APP_AUTHDEPOT_LOGOUT,
    REACT_APP_LOGOUT_URL,
  } = window.__ENV || {};

  const clearNewUserSessionStorage = () => {
    // Clear localStorage
    localStorage.removeItem('applicationID');
    localStorage.removeItem('applicationNavigationStatus');
    localStorage.removeItem('contactPhoneConsent');
    localStorage.removeItem('disableOnboardingInformations');
    localStorage.removeItem('personID');
    localStorage.removeItem('person-info-current-level');
    localStorage.removeItem('optin');
    localStorage.removeItem('workflowTokenValue');
    localStorage.removeItem('needSegmentMSRetry');
    localStorage.removeItem('lastAttemptType');

    let sessionVarKey;
    for (let i = 0; i < sessionStorage.length; i++) {
      sessionVarKey = sessionStorage.key(i);
      if (sessionVarKey.startsWith('task_')) {
        sessionStorage.removeItem(sessionVarKey);
      }
    }

    localStorage.removeItem('showOtp');  
    sessionStorage.removeItem('callerIdParam');
    sessionStorage.removeItem('isV4V5OtpVerified');
    sessionStorage.removeItem('otpCorrelatedId');
  };

  const logoutWithCustomRedirect = async redirectTo => {
    clearNewUserSessionStorage();
    await clearServerCookies();
    // Using userManager compatibility layer that will clear session storage
    userManager.signoutRedirect();

    // Redirect to the logout URL with the custom redirect
    window.location.replace(`${REACT_APP_OAUTH_COGNITO_LOGOUT}?client_id=${REACT_APP_OAUTH_CLIENT_ID}&logout_uri=${REACT_APP_AUTHDEPOT_LOGOUT}?callback=${redirectTo}`);
  };

  const logout = async () => {
    clearNewUserSessionStorage();
    await clearServerCookies();
    // Using userManager compatibility layer that will clear session storage
    userManager.signoutRedirect();

    // Redirect to the standard logout URL
    window.location.replace(`${REACT_APP_OAUTH_COGNITO_LOGOUT}?client_id=${REACT_APP_OAUTH_CLIENT_ID}&logout_uri=${REACT_APP_AUTHDEPOT_LOGOUT}?callback=${REACT_APP_LOGOUT_URL}`);
  };

  return {
    logout,
    logoutWithCustomRedirect,
    clearNewUserSessionStorage,
  };
}
